module.exports = __webpack_public_path__ + "img/close.022c3260.png";